import * as React from "react";
const SvgHistory = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", fill: "none", viewBox: "0 0 24 20", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeLinecap: "square", strokeWidth: 1.5, d: "m1.594 9.523 3.279 3.471 3.206-3.582M13.75 5.25v5.5h5" }), /* @__PURE__ */ React.createElement("path", { stroke: "currentColor", strokeWidth: 1.5, d: "M4.954 11.933A9.25 9.25 0 1 1 14 19.25" }));
export {
  SvgHistory as default
};
//# sourceMappingURL=history.js.map
